import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  IconButton,
} from "@material-ui/core";

import "./order.css";
import { connect } from "react-redux";
import { CheckCircle,  Cancel,HourglassEmpty } from "@material-ui/icons";

import { getNewOrders } from "../../../actions/sellerActions";
import orderListIcon from "../../../media/neworder.png";
import Loading from "../../Loading";

const NewOrders = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [listening, setListening] = useState(false);
  useEffect(() => {
    var source;
    if (!props.auth.isAuthenticated) {
      props.history.push(`/`);
    } else {
      if ("EventSource" in window) {
        source = new EventSource(
          "https://buyerserver.herokuapp.com/buyer/server/stream"
        );
        if (!listening) {
          source.addEventListener(
            "open",
            function (e) {
              setListening(true);
            },
            false
          );
        }

        source.addEventListener(
          `get-order-${props.auth.seller._id}`,
          function (e) {
            props.getNewOrders(props.auth.seller._id);
          },
          false
        );

        source.addEventListener(
          "error",
          function (error) {
            console.log(error);
          },
          false
        );
      }
    }
    return () => source.close();
  }, [props.auth.isAuthenticated]);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      props.getNewOrders(props.auth.seller._id);
      if (props.newOrders) {
        setData(props.newOrders);
        setLoading(false);
      }
    }
  }, [props.auth.isAuthenticated]);

  useEffect(() => {
    if (props.newOrders) {
      setData(props.newOrders);
      setLoading(false);
    }
  }, [props.newOrders]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <div
        style={{
          backgroundColor: "black",
          color: "white",
          padding: "1px 0 1px 30px",
          margin: "10px 0",
          borderRadius: "10px",
        }}
      >
        <div style={{ display: "flex",alignItems:'center' }}>
          <img
            src={orderListIcon}
            height="40px"
            width="40px"
            style={{ margin: "5px 10px 0 0" }}
            alt="Order List Icon"
          />
          <h3>New Orders</h3>
        </div>
      </div>
      {!loading && data.length === 0 ? (
        <div style={{ display: "flex" }}>
          <HourglassEmpty style={{ margin: "20px 20px 20px 0" }} />
          <h3>No New Order</h3>
        </div>
      ) : (
        <Grid container spacing={2}>
          {data.map((Order, i) => {
            const { buyer, order, _id, address } = Order;
            return (
              <Grid item xs={12} md={6} lg={4} key={i}>
                <Card variant="outlined">
                  {/* <CardActionArea> */}
                    {/* <Link
                      to={`/order/${_id}`}
                      style={{ textDecoration: "none" }}
                    > */}
                    <CardContent style={{ padding: "10px 0" }}>
                      <Typography
                        variant="h6"
                        style={{ marginLeft: "15px", color: "black" }}
                      >
                        {buyer.name}
                      </Typography>
                      <Table className="table">
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell className="bigDevices">
                              <b>Items</b>
                            </TableCell>
                            <TableCell numeric>
                              <b>Quantity</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {order.map((arder, i) => {
                          const { item, quantity } = arder;
                          return (
                            <TableBody key={i}>
                              <TableRow>
                                <TableCell>
                                  <img
                                    src={item.images[0]}
                                    style={{
                                      width: "75px",
                                      borderRadius: "13%",
                                    }}
                                    alt="ItemImage"
                                  />
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="bigDevices"
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell numeric>{quantity}</TableCell>
                              </TableRow>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </CardContent>
                    <div style={{ textAlign: "center" }}>
                      <p>
                        Address: <b>{address}</b>
                      </p>
                    </div>
                    <div style={{border:"rgba(192,192,192,0.4) 0.5px solid"}}/>
                    <div style={{ display: "flex", justifyContent: "space-around",margin:"15px 0" }}>
                      <Link
                        to={`/order/accept/${_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          variant="outlined"
                          style={{
                            color: "white",
                            backgroundColor: "limegreen",
                            borderRadius: "10px",
                            display:'flex',
                            alignItems:'center',
                            padding:'0 15px'

                          }}
                        >
                          <CheckCircle />
                          <p style={{marginLeft: 10}}>
                            Accept Order
                          </p>
                        </div>
                      </Link>
                      <Link
                        to={`/order/reject/${_id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          variant="outlined"
                          style={{
                            color: "white",
                            backgroundColor: "red",
                            borderRadius: "10px",
                            display:'flex',
                            alignItems:'center',
                            padding:'0 15px'
                          }}
                        >
                          <Cancel />
                          <p style={{marginLeft:10}}>
                            Reject Order
                          </p>
                        </div>
                      </Link>
                    </div>
                    {/* </Link> */}
                  {/* </CardActionArea> */}
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  newOrders: state.server.newOrders,
});
export default connect(mapStateToProps, { getNewOrders })(NewOrders);
